var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_vm.pageType == "DETAILS" ? _c("top-title", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      themeColor: _vm.themeColor
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保障责任")))])]) : _vm._e(), _vm.styleObj.controlsComponentsMark == "guarantee1" ? _c("div", [_c("div", {
    staticClass: "tabBox"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      class: index == _vm.tabIndex ? "hit" : ""
    }, [_c("div", {
      staticClass: "bg"
    }), _c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))])]);
  }), 0), _c("div", {
    staticStyle: {
      padding: "5px 15px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("方案说明：方案备注")) + " ")]), _c("div", {
    staticClass: "contBox"
  }, _vm._l(_vm.list[_vm.tabIndex].list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "infoBox"
    }, [_c("span", {
      style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_c("span", {
      style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]), item.info ? _c("div", {
      style: "color:" + _vm.themeColor,
      on: {
        click: function ($event) {
          return _vm.infoClickFun(index);
        }
      }
    }, [!item.isClick ? _c("a-icon", {
      attrs: {
        type: "down"
      }
    }) : _c("a-icon", {
      attrs: {
        type: "up"
      }
    })], 1) : _vm._e()])]), item.isClick ? _c("div", {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t(item.info)))]) : _vm._e()]);
  }), 0)]) : _vm.styleObj.controlsComponentsMark == "guarantee2" || _vm.styleObj.controlsComponentsMark == "guarantee3" ? _c("div", [_c("div", {
    staticClass: "tableBox"
  }, [_c("div", {
    staticClass: "tableHeader"
  }, [_c("div", {
    staticClass: "bg"
  }), _c("div", {
    staticClass: "tableList"
  }, [_c("div", {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t("保障责任")))]), _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "header"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  })], 2)]), _c("div", {
    staticClass: "tableList2",
    class: _vm.styleObj.controlsComponentsMark == "guarantee3" ? "border" : ""
  }, [_c("div", _vm._l(_vm.list[0].list, function (item, index) {
    return _c("div", {
      key: index,
      style: "font-size:" + _vm.styleObj.fieldFontSize + "px;color:" + _vm.styleObj.fieldColor
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 0), _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2,
        style: "font-size:" + _vm.styleObj.keyFontSize + "px;color:" + _vm.styleObj.keyColor
      }, [_vm._v(" " + _vm._s(_vm.$t(item2.value)) + " ")]);
    }), 0);
  })], 2)]), _vm.styleObj.controlsComponentsMark == "guarantee3" ? _c("div", {
    staticClass: "infoBox2"
  }, _vm._l(_vm.list[0].list, function (item, index) {
    return _c("div", {
      key: index
    }, [_vm._v(" " + _vm._s(_vm.$t(item.info)) + " ")]);
  }), 0) : _vm._e(), _vm.styleObj.controlsComponentsMark == "guarantee2" ? _c("div", {
    staticClass: "des"
  }, [_vm._v(" " + _vm._s(_vm.$t("备注：仅供参考，具体保险责任以保单和保险")) + " ")]) : _vm._e()]) : _vm._e(), _c("div", [_vm._t("edit")], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };